import React from 'react'
import { useSelector } from 'react-redux'

import Text from 'components/common/Text'
import { Color } from 'constants/color'
import { _isTeacher } from 'store/selectors/User'

import * as Styles from './styles'

import { assetsBase } from '../constants'
import { QuizStartButton } from '../MotionButton'
import QuizContainerBorder from '../QuizContainerBorder'

const StartQuizScreen = ({ quizSet, onProceed = () => {} }) => {
    const isTeacher = useSelector(_isTeacher)
    return (
        <Styles.Container>
            <Styles.ViewScreen>
                <Styles.Title>
                    <Text color={Color.black} level="7">
                        {quizSet?.name}
                    </Text>
                </Styles.Title>
                {isTeacher && <QuizStartButton onClick={onProceed} />}
                <Styles.Image src={`${assetsBase}/startQuizImage.svg`} />
            </Styles.ViewScreen>
            <QuizContainerBorder />
        </Styles.Container>
    )
}

export default StartQuizScreen
